import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type PurchaseCTAProps = {
  label?: string;
};
export function PurchaseCTA({
  label = 'Quiero mi sistema completo'
}: PurchaseCTAProps) {
  const scrollToPurchase = () => {
    document.getElementById('purchase')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <button onClick={scrollToPurchase} className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#2e1065] px-6 py-4 text-xs font-black uppercase tracking-[0.14em] text-white shadow-[0_16px_30px_-16px_rgba(46,16,101,0.8)] transition-colors duration-200 ease-out hover:bg-[#3d187f] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2e1065] sm:w-auto" data-id="element-261" data-mp="6kc0h196mgyu">
      {label}
      <ArrowRightIcon size={16} strokeWidth={2.5} className="transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-262" data-mp="1d80uwl8p3pd3" />
    </button>;
}